import { useState, useCallback } from 'react';

let _id = 0;

export const useToast = () => {
  const [toasts, setToasts] = useState([]);

  const addToast = useCallback(({ type = 'unlock', title, message, metadata = {} }) => {
    const id = ++_id;
    setToasts(prev => [...prev, { id, type, title, message, metadata }]);
    return id;
  }, []);

  const dismissToast = useCallback((id) => {
    setToasts(prev => prev.filter(t => t.id !== id));
  }, []);

  return { toasts, addToast, dismissToast };
};